var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-weight-medium caption tabular-nums"},[_vm._v(" "+_vm._s(_vm._f("format_date_short")(_vm.date))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }